import { api } from "@/lib/api";
import type { PrState } from "./task.service";

export interface TaskGithubLink {
	id: string;
	task_id: string;
	repo_owner: string;
	repo_name: string;
	branch_name: string;
	branch_created: boolean;
	pr_number: number | null;
	pr_url: string | null;
	pr_state: PrState;
	pr_title: string | null;
	head_sha: string | null;
	checks_state: "success" | "failure" | "pending" | null;
	updated_at: string;
}

export async function getTaskGithub(
	projectId: string,
	taskId: string,
	refresh = false,
): Promise<TaskGithubLink | null> {
	const res = await api.get<{ success: boolean; data: TaskGithubLink | null }>(
		`/projects/${projectId}/tasks/${taskId}/github${refresh ? "?refresh=1" : ""}`,
	);
	return res.data;
}

export async function createTaskBranch(
	projectId: string,
	taskId: string,
): Promise<TaskGithubLink> {
	const res = await api.post<{ success: boolean; data: TaskGithubLink }>(
		`/projects/${projectId}/tasks/${taskId}/github/branch`,
		{},
	);
	return res.data;
}

export async function unlinkTaskGithub(
	projectId: string,
	taskId: string,
): Promise<void> {
	await api.delete(`/projects/${projectId}/tasks/${taskId}/github`);
}
